"use strict";

import React from 'react/addons';
import Flux from 'fluxxor';
var FluxMixin = Flux.FluxMixin(React);

import SimpleChoice from 'ofs/components/simple-choice/SimpleChoice';
import i18n from 'ofs/i18n';

import {languages, user} from 'ofs/settings';
import {languageSelector as config} from 'ofs/payload';

var gettext = i18n.gettext;

var MESSAGES = {
  LABEL: gettext('Set your language')
};


var LanguageSelector = React.createClass({
  mixins: [FluxMixin],

  handleChange: function(event) {
    var {option} = event;
    this.getFlux().actions.tracking.sendGenericEvent({
      category: 'setLanguage',
      action: option.props['value']
    });
    this.getDOMNode().submit();
  },

  render: function() {
    var options = languages.map((language) => {
      return <div value={language['id']} key={language['id']}>{language['label']}</div>;
    });

    return (
      <form action={config.url} method="POST" className="ofs-LanguageSelector">
        <div className="ofs-LanguageSelector__InputContainer">
          <label className="ofs-LanguageSelector__Label">{MESSAGES.LABEL}</label>
          <SimpleChoice name="language" inverse={true}
            className="ofs-SimpleChoice--inline ofs-LanguageSelector__Select"
            defaultValue={user.languageCode} onChange={this.handleChange}>
            {options}
          </SimpleChoice>
        </div>
      </form>
    );
  }
});

export default LanguageSelector;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/views/LanguageSelector.jsx
 **/